
//////////////////////////////////////////////
//! Static Map generator form ACF fields
//////////////////////////////////////////////
staticMap = function(el, dispatcher) {

//--------------------------------------------
//! Static Vars
//--------------------------------------------
	this.el = el;
	this.markers = DOM.maps.markers;
	this.clusters = '';
	this.markerIco = $(DOM.data).data('wpthemeurl')+'/img/MapMarker-mini.svg';
	this.themeUrl = $(DOM.data).data('wpthemeurl');

	this.disableDefaultUI = false;
	this.gestureHandling = 'cooperative';

	if($(el).attr('disableui')) {
		//alert();
		this.disableDefaultUI = true;
		this.gestureHandling = 'none';
	}

	this.settings = {
		zoom 				: parseInt($(el).attr('data-mapZoom')),
		center				: new google.maps.LatLng(0, 0),
		mapTypeId			: google.maps.MapTypeId[$(el).attr('data-mapType')],
		disableDefaultUI		: $(el).attr('disableui'),
		mapTypeControl		: false,
		streetViewControl	: false,
		clickableIcons		: false, // prevent transport icons form being clickable
		gestureHandling		: this.gestureHandling,
		styles 				: snazzyMap // see `js/_vendor/snazzyMapStyle.js` for style
	};


//--------------------------------------------
//! Vars
//--------------------------------------------
	this.map = '';

//////////////////////////////////////////////
	this.init();
//////////////////////////////////////////////

};

staticMap.prototype = {

	constructor: staticMap,

	/*---------------------------------------------------
		INITIALIZER
	--------------------------------------------------*/

	init : function() {
		//console.log('GALLERY INIT')

		this.makeMap(this.el);

		// Start Events
		this.bindEvents();
	},

	/*---------------------------------------------------
		EVENT HANDLERS
	--------------------------------------------------*/
	bindEvents: function(){



	},


	/*---------------------------------------------------
		FUNCTIONS
	--------------------------------------------------*/
	makeMap:function(el){
		// console.log('Making a map');
		var $el = $(this.el);
		var $markers = $el.find(this.markers);
		//console.log($markers);

		// Settings
		var args = {
			zoom			: this.settings.zoom,
			center		: new google.maps.LatLng(0, 0),
			mapTypeId	: google.maps.MapTypeId.ROADMAP,
			styles		: this.settings.styles
		};


		// create map
		this.map = new google.maps.Map( $el[0], this.settings);

		// add a markers reference
		this.map.markers = [];


		// add markers
		for (i=0; i<$markers.length; i++) {
			// console.log($markers[i]);
			this.addMarker( $($markers[i]), this.map);
		}

		this.addClusters(this.map, this.map.markers);

		// center map
		this.centerMap(this.map);

		// return
		return this.map;
	},

	addMarker: function($marker, map){

		// console.log('ADDING MARKERS');

		// console.log($marker);

		var icon = this.themeUrl + '/img/MapMarker-006BA9.svg'; // fallback to default blue

		if ($marker.attr('data-iconColor')) {
			icon = this.themeUrl + '/img/MapMarker'+$marker.attr('data-iconColor')+'.svg'; // if colour specified
		}

		// or if an alternative icon supplied
		if ($marker.attr('data-iconSrc') != null) {
			icon = $marker.attr('data-icon');
		}

		var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
		// console.log(latlng);
		// create marker
		var marker = new google.maps.Marker({
			position		: latlng,
			map			: map,
			icon			: icon
		});



		// add to array
		this.map.markers.push( marker );

		if ($marker.attr('data-mapLink')) {

			google.maps.event.addListener(marker, 'click', function() {
				//window.location.href = $marker.attr('data-mapLink');
				//window.open($marker.attr('data-mapLink'), '_blank');

				var win = window.open($marker.attr('data-mapLink'), '_blank');
				if (win) {
				    //Browser has allowed it to be opened
				    win.focus();
				} else {
				    //Browser has blocked it
				    alert('New window blocked');
				}
			});
		}

		// if marker contains HTML, add it to an infoWindow
		if( $marker.html() )
		{
			// create info window
			var infowindow = new google.maps.InfoWindow({
				content		: $marker.html()
			});

			// show info window when marker is clicked
			google.maps.event.addListener(marker, 'click', function() {

				infowindow.open( map, marker );

			});
		}
	},

	centerMap: function(map){
		// vars
		var bounds = new google.maps.LatLngBounds();

		// loop through all markers and create bounds
		$.each( this.map.markers, function( i, marker ){

			var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

			bounds.extend( latlng );

		});

		// only 1 marker?
		if( map.markers.length == 1 )
		{
			// set center of map
			map.setCenter( bounds.getCenter() );
			map.setZoom( this.settings.zoom );
		}
		else
		{
			// fit to bounds
			map.fitBounds( bounds );
		}
	},

	addClusters: function(map, markers) {
		this.clusters =  new MarkerClusterer( map, markers,
		{
			ignoreHiddenMarkers : true,
			imagePath : this.clusterIco,
		});
	}
};
